<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div class="breadcrumbs-section padding-left">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/individual-invite">Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Individual Invite</span>
        </div>

        <div class="invite-layout" *ngIf="loadScreen">

          <div class="row">
            <div class="col-10 ml-0 pl-0">
              <h1 class="col-10">Invite</h1>
            </div>
            <div class="col-2"> <button (click)="navigate()">Bulk Invite</button></div>
          </div>

          <div class="row">
            <div class="col-12">
              <h2 class="mt-4">Host Details</h2>
            </div>
          </div>

          <div class="row mt-4">


            <div class="col-4">
              <div class="dropdown-border pointer-link" style="position: relative;">
                <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContentFullName"
                  triggers="manual" #pn="ngbPopover" (click)="openPopover(pn)" placement="bottom"
                  popoverClass='dash-popover dashboard-popover'>
                  <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link" readonly
                    [(ngModel)]="fullname" name="name" required>
                  <label class="form-lable-dropdown">Full Name</label>

                  <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                </div>
              </div>

              <ng-template #popContentFullName>
                <div class="dashboard-popover">
                  <div class="d-flex justify-content-between">
                    <div class="pl-3 pt-3 pr-3 pb-3 ">
                      <div class="row pb-2" *ngFor="let item of myCompanyData;let index =i"
                        (click)="setFullName(item); openPopover(pn);">
                        <div class="popover-content normal-font pl-3 email-width">
                          {{item.name}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>


            <div class="col-4">
              <div class="textbox-style">{{mobileNumber}}</div>
              <label class="form-lable">Mobile Number</label>
            </div>

            <div class="col-4">
              <div class="textbox-style">{{emailId}}</div>
              <label class="form-lable">Email-ID</label>
            </div>


          </div>
          <form #myForm=ngForm validate>
            <div class="row additionalMark mt-5">
              <div class="col-12">
                <p>Additional Remark<span>(Optional)</span></p>
              </div>
            </div>
            <div class="row additionalMark">
              <div class="col-12">
                <input type="text" [(ngModel)]="remarks" name="remarks">
              </div>
            </div>


            <div class="row">
              <div class="col-12">
                <h2 class="mt-4">Meeting Details</h2>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-2">
                <div class="date-container">
                  <input class="cal-icon textbox-style pointer-link pl-5" autocomplete="off" (click)="dp1.toggle()"
                    (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedDate($event)" id="owner-dob"
                    type="text" name="dp1" ngbDatepicker #dp1="ngbDatepicker" readonly placeholder="Date" required>
                  <span>{{formatDate}}</span>
                  <!-- <div *ngIf="dp1.invalid && (dp1.dirty || dp1.touched)" class="field-error pl-2">
                  <span *ngIf="dp1.errors?.required">* This field is mandatory</span>
                </div> -->
                </div>
              </div>


              <div class="col-2" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)"
                placement="bottom" popoverClass='starttime-popover'>
                <input type="text" class="textbox-style pl-3 pointer-link" placeholder="Start Time"
                  [(ngModel)]="startTimePlaceholder" required name="time" #time=ngModel>
                <img src="../../../assets/images/Path.png" class="dropdown-icon time-arrow" loading="lazy" />
                <!-- <div *ngIf="time.invalid && (time.dirty || time.touched||showError)" class="field-error pl-2">
              <span *ngIf="time.errors?.required">* This field is mandatory</span>
            </div> -->
                <ng-template #popContent1>
                  <div class="rectangle-copy-5">
                    <label class="start-time pl-4 pt-3">Start Time</label>
                    <div class="pl-3 pr-4 pt-1 ">
                      <ngb-timepicker [(ngModel)]="startTime" name="strtTime" [meridian]="meridian"
                        (ngModelChange)="onTimeChange($event)" [minuteStep]="15"></ngb-timepicker>
                      <div>
                        <span class="hh-margin">hh</span>
                        <span class="mm-margin">mm</span>
                      </div>
                      <div class="toggle-position">
                        <label class="switch">
                          <input #saveamorpmCheckBox type="checkbox" id="saveamorpmCheckBox" [checked]="amorpm"
                            (change)="toggleAmPmSelection(saveamorpmCheckBox.checked)">
                          <span class="bookslider"></span>
                        </label>
                      </div>

                    </div>
                  </div>

                </ng-template>
              </div>


              <div class="col-4">
                <div class="dropdown-border pointer-link" style="position: relative;">
                  <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                    [ngbPopover]="popContentBuildingName" triggers="manual" #p="ngbPopover"
                    (click)="openPopover(p);enterName('buildingName')" placement="bottom"
                    popoverClass='dash-popover dashboard-popover'>
                    <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                      [placeholder]="!buildingName ? 'Building Name' : ''" readonly [(ngModel)]="buildingTitle"
                      name="building" #building=ngModel required>
                    <label *ngIf="buildingName" class="form-lable-dropdown">Building Name</label>

                    <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                    <div *ngIf="building.invalid && (building.dirty || building.touched ||showError)" class="field-error pl-2">
                      <span *ngIf="building.errors?.required">* This field is mandatory</span>
                    </div>
                  </div>
                </div>

                <ng-template #popContentBuildingName>
                  <div class="dashboard-popover">
                    <div class="d-flex justify-content-between">
                      <div class="pl-3 pt-3 pr-3 pb-3 ">
                        <div class="row pb-2" *ngFor="let item of buildingProperty;let index =i"
                          (click)="setBuildingName(item?.parkBuildingId,item?.buildingName); openPopover(p);">
                          <div class="popover-content normal-font pl-3 email-width">
                            {{item.buildingName}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="col-4">
                <div class="dropdown-border pointer-link" style="position: relative;">
                  <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popFloorContent"
                    triggers="manual" #pf="ngbPopover" (click)="openPopover(pf);enterName('floor')" placement="bottom"
                    popoverClass='dash-popover dashboard-popover'>
                    <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                      [placeholder]="!floor ? 'Floor (Optional)' : ''" readonly [(ngModel)]="floorTitle" name="flr"
                      #flr='ngModel' required>
                    <label *ngIf="floor" class="form-lable-dropdown">Floor</label>

                    <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                    <div *ngIf="flr.invalid && (flr.dirty || flr.touched ||showError)" class="field-error pl-2">
                      <span *ngIf="flr.errors?.required">* This field is mandatory</span>
                    </div>
                  </div>
                </div>

                <ng-template #popFloorContent>
                  <div class="dashboard-popover">
                    <div class="d-flex justify-content-between">
                      <div class="pl-3 pt-3 pr-3 pb-3 ">
                        <div class="row pb-2" *ngFor="let item of floorList;let index =i"
                          (click)="setFloor(item); openPopover(pf);">
                          <div class="popover-content normal-font pl-3 email-width">
                            {{item}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <p class="blue-text  mt-2">*Visitors are allowed in the park only between 7 am - 7 pm.</p>
              </div>
              <div class="col-8"></div>
            </div>

            <div class="guest  mt-5" *ngFor="let item of guestList; let i=index">

              <div class="row" style="align-items: baseline;">
                <div class="col-10">
                  <h3>Guest {{i+1}}</h3>
                </div>
                <div class="col-2"> <button class="button-clear-guest" *ngIf="guestList.length>1" type="submit"
                    (click)="removeGuest(item.srNo)">Clear</button></div>
              </div>

              <div class="row mt-4">
                <div class="col-4">
                  <input type="text" [ngClass]="guestName?'textbox-onselect':'textbox-style'  "
                    class="search-line  pl-4 placeholder-text " [(ngModel)]="item.fullName" name="fullName_{{i}}"
                    [placeholder]="!guestName ? 'Full Name' : ''" (click)="enterName('guestName')"
                    (blur)="enterName('guestName')" required>
                  <label *ngIf="guestName" class="form-lable">Full Name</label>
                  <div *ngIf="error[item.fullName+i]" class="field-error">
                    <span>* This field is mandatory</span>
                  </div>
                </div>
                <div class="col-4">
                  <input type="text" name="mobile_{{i}}" [ngClass]="guestMobile?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [(ngModel)]="item.mobile"
                    [placeholder]="!guestMobile ? 'Mobile Number' : ''" (click)="enterName('guestMobile')"
                    (blur)="enterName('guestMobile')" required maxlength="10">
                  <label *ngIf="guestMobile" class="form-lable">Mobile Number</label>
                  <div *ngIf="error[item.mobile+i]" class="field-error">
                    <span>* Please enter valid Mobile Number</span>
                  </div>
                </div>
                <div class="col-4">
                  <input type="text" required name="email_{{i}}"
                    [ngClass]="guestEmail?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [(ngModel)]="item.email"
                    [placeholder]="!guestEmail ? 'Email-Id' : ''" (click)="enterName('guestEmail')"
                    (blur)="enterName('guestEmail')">
                  <label *ngIf="guestEmail" class="form-lable">Email-Id</label>
                  <div *ngIf="error[item.email+i]" class="field-error">
                    <span>* Please enter valid email</span>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-4">

                  <input type="text" class="textbox-style search-line  pl-4 placeholder-text"
                    placeholder="Visitor Company Name" [(ngModel)]="item.companyName" required name="companyName_{{i}}">
                  <div *ngIf="error[item.companyName+i]" class="field-error">
                    <span>* This field is mandatory</span>
                  </div>
                </div>
                <div class="col-8"></div>
              </div>

              <!-- <div class="row">
                <div class="col-12">
                  <h4 class="mt-4">Vehicle Details (Optional)</h4>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-4">

                  <div class="dropdown-border pointer-link" style="position: relative;">
                    <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                      [ngbPopover]="popContentPropertyType" triggers="manual" #pt="ngbPopover"
                      (click)="openPopover(pt);enterName('buildingName')" placement="bottom"
                      popoverClass='dash-popover dashboard-popover'>
                      <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                        [placeholder]="!buildingName ? 'Vehicle Type' : ''" [(ngModel)]="item.vehicleType" required
                        name="vehicleType_{{i}}" readonly required>
                      <label *ngIf="buildingName" class="form-lable-dropdown">Vehicle Type</label>
                      <div *ngIf="error[item.vehicleType+i]" class="field-error">
                        <span>* This field is mandatory</span>
                      </div>

                      <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                    </div>
                  </div>

                  <ng-template #popContentPropertyType>
                    <div class="dashboard-popover">
                      <div class="d-flex justify-content-between">
                        <div class="pl-3 pt-3 pr-3 pb-3 ">
                          <div class="row pb-2" *ngFor="let item of vehicleTypeList;let index =i"
                            (click)="setVehicleType(item.vehicleType,item.vehicleTypeId,i); openPopover(pt);">
                            <div class="popover-content normal-font pl-3 email-width">
                              {{item.vehicleType}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>


                </div>
                <div class="col-4">
                  <input type="text" required [ngClass]="vehicleNumber?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [(ngModel)]="item.vehicleNo" name="vehicleNo_{{i}}"
                    [placeholder]="!vehicleNumber ? 'Vehicle Number' : ''" (click)="enterName('vehicleNumber')"
                    (blur)="enterName('vehicleNumber')">
                  <label *ngIf="vehicleNumber" class="form-lable">Vehicle Number</label>
                  <div *ngIf="error[item.vehicleNo+i]" class="field-error">
                    <span>* This field is mandatory</span>
                  </div>
                </div>
              </div> -->

              <div class="col-4"></div>
            </div>
            <div class="row">
              <button class="button-add-guest col-3  mt-2 ml-0" (click)="addGuest()">+ Add another guest</button>
              <div class="col-8"></div>
            </div>
            <p>* To invite more than 10 guests, please use Bulk Invite.</p>
            <hr class="mt-4">

            <div class="row">
              <div class="col-8"></div>
              <div class="col-2">
                <button class="button-cancel" (click)='cancel()'>Cancel</button>
              </div>
              <div class="col-2">
                <button (click)="invite(myForm)" class="button-invite">Invite</button>
              </div>
            </div>

          </form>


          <div class="row mt-3">
            <div class="col-12">
              <p class=" text">An invititation with meeting details and QR code will be sent to the guest email and
                mobile number.</p>
            </div>

          </div>
        </div>
      </div>









    </div>

    <!-- <app-footer></app-footer> -->

  </div>
</div>
